<template>
  <div class="product" >
    <part v-for="part in cart.parts" :key="'part-' + part.id" :part="part" :reverse="reverse"></part>
    <letter v-for="letter in cart.letters" :key="'letter-' + letter.id" :letter="letter" :reverse="reverse"></letter>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import Part from './Part.vue'
  import Letter from './Letter.vue'

  export default {
    name: 'product',
    components: {
      Part,
      Letter,
    },
    props: ['reverse'],
    computed: {
      ...mapState(['cart']),
    },
  }
</script>
